// JsFromRoutes CacheKey ac2c4519e107526ae476552a64b02a1c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  submitUnitApplication: /* #__PURE__ */ definePathHelper('post', '/admin/members/:member_id/submit_unit_application'),
  freezeUnitAccount: /* #__PURE__ */ definePathHelper('post', '/admin/members/:member_id/freeze_unit_account'),
  unfreezeUnitAccount: /* #__PURE__ */ definePathHelper('post', '/admin/members/:member_id/unfreeze_unit_account'),
  toggleSupportMode: /* #__PURE__ */ definePathHelper('patch', '/admin/members/:member_id/toggle_support'),
  updateConfigurableOptions: /* #__PURE__ */ definePathHelper('patch', '/admin/members/:member_id/update_configurable_options'),
  deletePlaidAccount: /* #__PURE__ */ definePathHelper('delete', '/admin/members/:id/delete_plaid_account'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/members'),
  edit: /* #__PURE__ */ definePathHelper('get', '/admin/members/:id/edit'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/members/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/members/:id'),
}
